import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface MunicipioState {
    status: string;
    error: string;
    municipioList: any[],
    municipioListActive: any[],
    municipio: {
        idDepartamento: number | null;
        idMunicipio: number | null;
        nombre: string | null;
    }

}

const initialState: MunicipioState = {
    status: 'idle',
    error: '',
    municipioList: [],
    municipioListActive: [],
    municipio: {
        idDepartamento: null,
        idMunicipio: null,
        nombre: null
    }
}

export const fetchMunicipio = createAsyncThunk('fetchMunicipio', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 41;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchMunicipioActive = createAsyncThunk('fetchMunicipioActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 42;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const municipioSlice = createSlice({
    name: 'municipio',
    initialState,
    reducers: {
        setMunicipioList: (state, action) => {
            state.municipioList = action.payload;
        },
        setMunicipioListActive: (state, action) => {
            state.municipioListActive = action.payload;
        },
        setMunicipio: (state, action) => {
            state.municipio = !action.payload ? initialState.municipio : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchMunicipio.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMunicipio.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.municipioList = data ? data : [];

            })
            .addCase(fetchMunicipio.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchMunicipioActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMunicipioActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.municipioListActive = data ? data : [];

            })
            .addCase(fetchMunicipioActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectMunicipioList = (state: RootState) => state.municipio.municipioList;
export const selectMunicipioListActive = (state: RootState) => state.municipio.municipioListActive;
export const selectMunicipio = (state: RootState) => state.municipio.municipio;

export const { setMunicipioList, setMunicipioListActive, setMunicipio } = municipioSlice.actions;

export default municipioSlice.reducer;



